import { toast } from 'react-toastify';
import { ROUTES } from 'src/constants/routes';
import { ValidateApplicationPolicySuccessResponse } from '../../../configs/APISchemas/ValidateUserPolicyGraphQL';
import { COMPLIANCE_APPLICATION_STATUS } from 'src/constants/compliance';
import { ContactSupportId } from 'src/constants/constants';

export const handleApplicationStatus = (
  responseData: ValidateApplicationPolicySuccessResponse['validateApplicationPolicy'],
) => {
  const applicationStatus = responseData?.application?.status;
  let routeToNavigateTo = null;

  switch (applicationStatus) {
    case COMPLIANCE_APPLICATION_STATUS.COMPLIANT: {
      routeToNavigateTo = ROUTES.COMPLIANCE_ALREADY_VERIFIED_PATH;
      break;
    }
    case COMPLIANCE_APPLICATION_STATUS.COMPLIANCE_STARTED:
    case COMPLIANCE_APPLICATION_STATUS.NEEDS_REVIEW: {
      routeToNavigateTo = ROUTES.COMPLIANCE_UPLOAD_SUCCESS_PATH;
      break;
    }
  }

  return routeToNavigateTo;
};

export const handleError = (error: any) => {
  const errorData = error?.response?.data?.errors;
  const errorMessage =
    errorData?.[0]?.message ??
    `We are having some trouble, Please contact support for help. id: ${ContactSupportId.complianceHelpers}`;

  toast(errorMessage, {
    type: 'error',
  });
};
